module.exports = __webpack_public_path__ + "img/checklist.e798d906.svg";